import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTable, usePagination } from "react-table";
import ReactPaginate from "react-paginate";
import "./Contacts.css";

function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [error, setError] = useState("");
  const [replyEmail, setReplyEmail] = useState("");
  const [replySubject, setReplySubject] = useState("");
  const [replyMessage, setReplyMessage] = useState("");
  const [replyContactId, setReplyContactId] = useState(null);
  const [currentContact, setCurrentContact] = useState(null);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/contacts`
        );
        setContacts(response.data);
      } catch (error) {
        console.error("Error fetching contacts:", error);
        setError("Failed to load contacts.");
      }
    };

    fetchContacts();
  }, []);

  const handleReply = (contact) => {
    setReplyEmail(contact.email);
    setReplySubject(`Reply from SUNDORI: ${contact.subject}`);
    setReplyContactId(contact.id);
  };

  const sendReply = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/send_reply`, {
        email: replyEmail,
        subject: replySubject,
        message: replyMessage,
        contact_id: replyContactId,
      });
      alert("Reply sent successfully");
      setReplyEmail("");
      setReplySubject("");
      setReplyMessage("");
      setReplyContactId(null);
    } catch (error) {
      console.error("Error sending reply:", error);
      alert("Failed to send reply.");
    }
  };

  const data = React.useMemo(() => contacts, [contacts]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Subject",
        accessor: "subject",
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="contacts-card-actions">
            <button
              className="btn-reply"
              onClick={() => handleReply(row.original)}
            >
              Reply
            </button>
            <button className="btn-archive">Archive</button>
            <button className="btn-delete">Delete</button>
          </div>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    usePagination
  );

  const handleContactClick = (contact) => {
    setCurrentContact(contact);
  };

  return (
    <div className="contacts">
      <h2>User Messages</h2>
      {error && <div className="error-message">{error}</div>}
      <table {...getTableProps()} className="contacts-table">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                onClick={() => handleContactClick(row.original)}
              >
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        breakLabel={"..."}
        pageCount={pageOptions.length}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={({ selected }) => gotoPage(selected)}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />

      {currentContact && (
        <div
          className={`contacts-card-expanded ${currentContact ? "open" : ""}`}
        >
          <h3>{currentContact.name}</h3>
          <p>
            <strong>Email:</strong> {currentContact.email}
          </p>
          <p>
            <strong>Subject:</strong> {currentContact.subject}
          </p>
          <p>
            <strong>Message:</strong> {currentContact.message}
          </p>
        </div>
      )}

      {replyContactId && (
        <div className={`reply-modal ${replyContactId ? "open" : ""}`}>
          <h3>Reply to {replyEmail}</h3>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendReply();
            }}
          >
            <div className="modal-input-container">
              <label>Subject:</label>
              <input
                type="text"
                value={replySubject}
                onChange={(e) => setReplySubject(e.target.value)}
              />
            </div>
            <div className="modal-input-container">
              <label>Message:</label>
              <textarea
                value={replyMessage}
                onChange={(e) => setReplyMessage(e.target.value)}
              ></textarea>
            </div>
            <div className="contacts-btn-container">
              <button type="submit">Send Reply</button>
              <button type="button" onClick={() => setReplyContactId(null)}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default Contacts;
